import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import humanTime from 'flarum/common/helpers/humanTime';
import LabelValue from 'flarum/common/components/LabelValue';
import ItemList from 'flarum/common/utils/ItemList';
export default class ProviderInfo extends Component {
  view(_vnode) {
    const {
      provider
    } = this.attrs;
    if (provider.orphaned()) {
      return m("div", null, m("p", {
        className: "LinkedAccountsList-item-title"
      }, provider.name()), m("p", {
        className: "helpText"
      }, app.translator.trans('fof-oauth.forum.user.settings.linked-account.orphaned-account')), m("div", {
        className: "LinkedAccountsList-item-data"
      }, this.providerInfoItems(provider).toArray()));
    }
    if (provider.linked()) {
      return m("div", null, m("p", {
        className: "LinkedAccountsList-item-title"
      }, app.translator.trans("fof-oauth.forum.providers.".concat(provider.name()))), m("div", {
        className: "LinkedAccountsList-item-data"
      }, this.providerInfoItems(provider).toArray()));
    }
    return m("div", null, m("p", {
      className: "LinkedAccountsList-item-title"
    }, app.translator.trans("fof-oauth.forum.providers.".concat(provider.name()))));
  }
  providerInfoItems(provider) {
    const items = new ItemList();
    items.add('firstLogin', m(LabelValue, {
      label: app.translator.trans('fof-oauth.forum.user.settings.linked-account.link-created-label'),
      value: humanTime(provider.firstLogin())
    }), 100);
    items.add('lastLogin', m(LabelValue, {
      label: app.translator.trans('fof-oauth.forum.user.settings.linked-account.last-used-label'),
      value: humanTime(provider.lastLogin())
    }), 90);
    items.add('identification', m(LabelValue, {
      label: app.translator.trans('fof-oauth.forum.user.settings.linked-account.identification-label', {
        provider: app.translator.trans("fof-oauth.forum.providers.".concat(provider.name()))
      }),
      value: provider.identifier()
    }), 80);
    return items;
  }
}
flarum.reg.add('fof-oauth', 'forum/components/ProviderInfo', ProviderInfo);